import { createTheme } from '@mui/material/styles';

// Central design tokens. MUI's theme cascades to every component's defaults,
// so changes here lift the whole app without touching individual pages.
const theme = createTheme({
  palette: {
    primary: { main: '#1565c0', dark: '#0d47a1', light: '#5e92f3' },
    secondary: { main: '#6a1b9a' },
    success: { main: '#2e7d32' },
    warning: { main: '#c77700' },
    info: { main: '#0277bd' },
    error: { main: '#c62828' },
    background: { default: '#f4f6f9', paper: '#ffffff' },
    text: { primary: '#1a2233', secondary: '#5c6b7a' },
    divider: '#e3e8ef',
  },
  shape: {
    borderRadius: 8,
  },
  typography: {
    fontFamily: [
      '-apple-system', 'BlinkMacSystemFont', '"Segoe UI"', 'Roboto',
      '"Helvetica Neue"', 'Arial', 'sans-serif',
    ].join(','),
    // MUI scales every variant off this base (default 14) — this number moves
    // body text, table cells, buttons, and captions together proportionally,
    // instead of hand-tuning each variant.
    fontSize: 13,
    h4: { fontWeight: 700, letterSpacing: '-0.01em' },
    h5: { fontWeight: 700, letterSpacing: '-0.01em' },
    h6: { fontWeight: 600 },
    subtitle1: { fontWeight: 600 },
    subtitle2: { fontWeight: 600 },
    button: { fontWeight: 600 },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: { backgroundColor: '#f4f6f9' },
      },
    },
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: { textTransform: 'none', borderRadius: 8 },
        sizeLarge: { padding: '10px 22px' },
        contained: {
          '&:hover': { boxShadow: '0 2px 8px rgba(21,101,192,0.28)' },
        },
        outlined: { borderWidth: 1.5, '&:hover': { borderWidth: 1.5 } },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: { boxShadow: '0 1px 3px rgba(15,23,42,0.12)' },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: { backgroundImage: 'none' },
        rounded: { borderRadius: 10 },
        elevation1: { boxShadow: '0 1px 3px rgba(15,23,42,0.08)' },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          boxShadow: '0 1px 3px rgba(15,23,42,0.08)',
          border: '1px solid #e3e8ef',
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          fontWeight: 600,
          color: '#3a4655',
          backgroundColor: '#f7f9fc',
          whiteSpace: 'nowrap',
        },
        root: { borderColor: '#eceff3' },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          '&:hover td': { backgroundColor: 'rgba(21,101,192,0.04)' },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: { fontWeight: 600 },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: { borderRadius: 8 },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: { fontSize: '0.75rem' },
      },
    },
    MuiTabs: {
      styleOverrides: {
        indicator: { height: 3, borderRadius: '3px 3px 0 0' },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: { fontWeight: 600, minHeight: 56 },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: { fontWeight: 700 },
      },
    },
  },
});

export default theme;
